<ng-container
  *ngLet="{
    idValueChangeSub: idValueChangeSub | async,
    optionValueChangeSub: optionValueChangeSub | async
  } as vm"
>
  <deprecated-labeled-field
    [label]="label"
    [help]="help"
    [required]="required"
    [actionText]="actionText"
    (action)="action.emit()"
  >
    <deprecated-single-select-dropdown
      #dropdown
      [placeholder]="placeholder"
      [options]="options"
      [optionsLoadable]="optionsLoadable | async"
      [loadable]="loadable"
      [disabled]="disabled"
      [error]="error"
      [warning]="warning"
      [exact]="exact"
      [filterable]="filterable"
      [dismiss]="dismiss | async"
      (selectedOptionChange)="optionValueChange.next($event)"
      (selectedOptionIdChange)="idValueChange.next($event)"
      [selectedOption]="valueType == ValueType.Option ? optionValue : undefined"
      [selectedOptionId]="valueType == ValueType.ID ? idValue : undefined"
      (filter)="filter.next($event)"
    >
      <ng-container *ngIf="nodeDirective">
        <ng-container *singleSelectNode="let node">
          <ng-container
            *ngTemplateOutlet="
              nodeDirective.template;
              context: {
                $implicit: node,
                clickHandler: dropdown.singleSelect
              }
            "
          ></ng-container>
        </ng-container>
      </ng-container>
      <ng-content></ng-content>
    </deprecated-single-select-dropdown>
  </deprecated-labeled-field>
</ng-container>
